export const environment = {
  production: true,
  apiUrl: 'https://dev-v2.click2sell.com',
  wsUrl: 'wss://dev-v2.click2sell.com/ws',
};
